import { NavigationSubItem } from "../navigation-item"

export class DesignComponentsSubItem extends NavigationSubItem {
  readonly id = "design-components"
  readonly label = "Components"
  readonly href = "/design/components"
  readonly iconName = "design-components-icon"
  readonly isExternal = false
  readonly tabs = []
}

